import { render, staticRenderFns } from "./xz.vue?vue&type=template&id=1f4945f6&scoped=true&"
import script from "./xz.vue?vue&type=script&lang=js&"
export * from "./xz.vue?vue&type=script&lang=js&"
import style0 from "./xz.vue?vue&type=style&index=0&id=1f4945f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4945f6",
  null
  
)

export default component.exports